import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2fed18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-sub-container left" }
const _hoisted_2 = { class: "header-sub-container center" }
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = { class: "header-sub-container right" }

import {bool} from 'vue-types';
    import {useStore} from 'vuex';
    import {computed} from 'vue';

    const MaltLogoPath = '//dam.malt.com/rebranding2020/malt-logo/malt-red';
    const MaltStrategyLogoPath = '//dam.malt.com/rebranding2020/various-logos/malt-strategy.svg?vh=88b1c9';

    enum StepMobileHeaderEvents {
        CLICK_PREVIOUS = 'click:previous',
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'StepMobileHeader',
  props: {
        showButtonPrevious: bool().def(true),
    },
  setup(__props, { emit }) {

const props = __props;

    const store = useStore();
    const isMaltStrategy = computed(() => store.state.isFunnelStrategy);
    const imageProps = computed(() => {
        const height = isMaltStrategy.value ? '33' : '60';
        const width = isMaltStrategy.value ? '236' : '125';
        const alt = `malt ${isMaltStrategy.value ? 'strategy ' : ''}logo`;
        const src = isMaltStrategy.value ? MaltStrategyLogoPath : MaltLogoPath;

        return {height, width, alt, src};
    });

    

    

    function handleClickOnPrevious(): void {
        emit(StepMobileHeaderEvents.CLICK_PREVIOUS);
    }

    function dataTestId(action: string): string {
        return `step-actions-cta-mobile-${action}`;
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_icon_button = _resolveComponent("joy-icon-button")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      (props.showButtonPrevious)
        ? (_openBlock(), _createBlock(_component_joy_icon_button, {
            key: 0,
            icon: "arrow-left",
            class: "profile-creation-wizard__content-header-previous",
            "arial-label": _ctx.$msg('generic.navigation.button.prev'),
            title: _ctx.$msg('generic.navigation.button.prev'),
            "data-testid": dataTestId('previous'),
            onClick: handleClickOnPrevious
          }, null, 8, ["arial-label", "title", "data-testid"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "/",
        "data-testid": dataTestId('home-page')
      }, [
        _createElementVNode("img", _normalizeProps(_guardReactiveProps(imageProps.value)), null, 16)
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "right")
    ])
  ]))
}
}

})